import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTermsOfService } from '../redux/slice/termsOfService.slice';
import gsap from 'gsap';
import 'react-quill-new/dist/quill.snow.css';
import { Helmet } from 'react-helmet-async';
import LegalDocumentPreview from '../components/legal/LegalDocumentPreview';

export default function TermsOfService() {
    const dispatch = useDispatch();
    const { terms, loading } = useSelector((state) => state.termsOfService);

    useEffect(() => {
        dispatch(fetchTermsOfService());
    }, [dispatch]);

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from('.terms-reveal', {
                y: 28,
                opacity: 0,
                duration: 0.75,
                stagger: 0.07,
                ease: 'power3.out',
                clearProps: 'all',
            });
        });
        return () => ctx.revert();
    }, []);

    return (
        <>
            <Helmet>
                <title>Terms of Service | CUBE GAMES</title>
                <meta name="description" content="Read the Cube Games Terms of Service describing user guidelines, licensing, payment terms, and platform fair-play rules." />
                <meta name="keywords" content="terms of service, user agreement, licensing rules, cube games legal" />
                <link rel="canonical" href="https://cubegames.ca/terms" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Terms of Service | CUBE GAMES" />
                <meta property="og:description" content="Read the Cube Games Terms of Service describing user guidelines, licensing, payment terms, and platform fair-play rules." />
                <meta property="og:url" content="https://cubegames.ca/terms" />
            </Helmet>

            <LegalDocumentPreview
                variant="terms"
                sections={terms || []}
                loading={loading}
                revealClass="terms-reveal"
            />
        </>
    );
}
